export const normalizeAddress = (input: string) =>
    input
        .toLowerCase()
        .replace(/\s+/g, "")
        .replace(/[^a-z0-9_-]/g, "");

/**
 * Normalize a brand name by allowing only:
 * - Latin letters (a–z, A–Z)
 * - Numbers (0–9)
 * - Spaces
 * - Underscores (_)
 * - Dashes (-)
 * - Dots (.)
 * - Ampersands (&)
 * - Apostrophes (')
 * - Exclamation marks (!)
 */
export const normalizeBrandName = (input: string): string => {
    return input.replace(/[^a-zA-Z0-9 _.\-&'!]/g, "");
};
